import React, { useEffect, useState } from "react";
import { object, func } from "prop-types";
import get from "lodash/get";
import { FaqSection } from "../../faq/faq-section";
import { Attribute } from "../../attribute";
import { getPlanPrice, getLocaleDate } from "../../../../utils";
import { useDeviceType } from "../../../../customHooks/useDeviceType";
import "./group-and-plans.m.css";

export const GroupsAndPlansModal = ({
  member,
  setActiveTab,
  selectedPlan,
  setSelectedPlan,
  getSubscription,
  initRazorPayPayment,
  localizedMonths,
}) => {
  const [subscriptionsData, setSubscriptionsData] = useState([]);
  const [selectedSubscriptions, setSelectedSubscriptions] = useState({});
  const [isRecurringPlan, setIsRecurringPlan] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const isMobile = useDeviceType() !== "desktop";

  const group = subscriptionsData?.[0] || {};
  const plans = group?.subscription_plans || [];

  const filteredList = plans.filter((planItem) => planItem.recurring === false);
  const [selectedPlans, setSelectedPlans] = useState(filteredList);
  const [currentPlan, setCurrentPlan] = useState();

  const mapPlan = { month: "Pay Monthly", year: "Pay Yearly" };

  const handleActiveSubscriptionError = (error) => {
    const { end_timestamp: endTimestamp, plan_occurrence: planOccurrence } = error?.payload?.subscription || {};
    if (planOccurrence === "One Time" || planOccurrence === "Recurring") {
      const updatedTimestamp = endTimestamp ? getLocaleDate(endTimestamp, localizedMonths) : "";
      const errMessage = "Dear user, you already have an Active subscription!.";
      setErrorMessage(errMessage);
      console.log("Active Subscription ERROR 333-----", updatedTimestamp, planOccurrence, errMessage);
      window.location.href = `/subscription-failure?errorMsg=${errMessage}`;
    }
  };

  const paymentGateway = async (plan) => {
    const updatedPlan = JSON.parse(JSON.stringify(plan));
    console.log("Submitting Selected Plan 111-----", plan);
    try {
      const isFreePlan = updatedPlan.discounted_price_cents === 0 || updatedPlan.price_cents === 0;
      const paymentResponse = isFreePlan
        ? await initRazorPayPayment(updatedPlan, "standard", "", "", "", "skip_payment_gateway")
        : await initRazorPayPayment(updatedPlan, "standard");

      console.log("Payment Repsonse TRY 222-----", paymentResponse);

      if (paymentResponse.subscription) {
        window.location.href = "/subscription-success";
      }
    } catch (error) {
      console.log("Payment Repsonse CATCH 222-----", error, error?.error?.code);

      if (error?.error?.code === "subscription_preview_active_subscription") {
        handleActiveSubscriptionError(error?.error);
      } else {
        console.error("Subscription: ", error);
        setErrorMessage(error);
        console.log("Other Subscription ERROR 333-----", error);
        window.location.href = `/subscription-failure?errorMsg=${error}`;
      }
    }
  };

  const handlePlanSelection = (plan) => {
    setIsLoading(true);
    setSelectedPlan(plan);
    const processPayment = async () => {
      if (member) {
        await paymentGateway(plan);
      } else {
        setActiveTab("login");
      }
      setIsLoading(false);
    };
    processPayment();
  };

  useEffect(() => {
    getSubscription().then((res) => setSubscriptionsData(res));
  }, []);

  useEffect(() => {
    const defaultSelectedOptions = {};
    subscriptionsData.forEach((group, id) => {
      const firstPlan = get(group, ["subscription_plans", "0"]);
      defaultSelectedOptions[group.name] = firstPlan;
    });
    setSelectedSubscriptions(defaultSelectedOptions);
    // setSelectedPlans(plans.filter((planItem) => planItem.recurring === false));
  }, [subscriptionsData]);

  useEffect(() => {
    const filteredList = plans.filter((plan) => plan.recurring === isRecurringPlan);
    const selectedPlan = filteredList.find((plan) => plan.duration_unit === (currentPlan?.duration_unit || "year"));

    setCurrentPlan(selectedPlan);
    setSelectedPlans(filteredList);
  }, [isRecurringPlan, plans]);

  const bgImage = {
    backgroundImage: 'url("/images/banners/Subscription-bg.png")',
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: isMobile ? "90% top" : "center top",
  };

  return (
    <>
      <div styleName="top-section" style={bgImage}>
        <div styleName="headline-section">
          <div styleName="title">
            <p>Subscribe to Open Magazine Ad-Free reading experience</p>
          </div>

          <div styleName="sub-title">
            <p>Business Insights, Uninterrupted!</p>
          </div>

          <div styleName="description">
            <p>
              Experience the best of business journalism, where deep insights, trusted analysis, and unparalleled
              expertise guide decision-makers.
            </p>
            <br />
            <br />
            <p>Upgrade to the ad-free experience and focus on what truly matters — being ahead.</p>
          </div>
        </div>
        <div styleName="plan-div">
          {selectedPlans.map((plan, index) => {
            const {
              price_currency: priceCurrency,
              price_cents: priceCents,
              id,
              duration_unit: planUnit,
              custom_attributes: customAttributes,
            } = plan;

            const isOdd = selectedPlans?.length % 2 !== 0;
            const isLast = index === selectedPlans?.length - 1;
            const shouldCenter = isOdd && isLast;

            const shouldHighlight = (!currentPlan && planUnit === "year") || currentPlan === plan;

            const updatedBorderColor = {
              border: shouldHighlight ? "2px solid #C6554F" : "1px solid #00000029",
            };

            const duration = planUnit.charAt(0).toUpperCase() + planUnit.slice(1);
            const gridStyle = `${shouldCenter ? "plan center-if-last" : "plan"}`;
            return (
              <div
                styleName={gridStyle}
                key={`plan-${id}`}
                style={updatedBorderColor}
                onClick={() => setCurrentPlan(plan)}
              >
                <label styleName="radio-container">
                  <div>
                    <input type="radio" checked={shouldHighlight ? "checked" : ""} name="radio" />
                    <span styleName="checkmark" style={{ color: updatedBorderColor }}></span>
                  </div>
                  <div styleName="plan-section">
                    <div styleName="plan-title-price">
                      <div styleName="pay-title">{mapPlan[planUnit]}</div>
                      <div styleName="price-wrapper" data-test-id="amount">
                        {getPlanPrice(priceCurrency, priceCents)} / {duration} Per Member
                      </div>
                    </div>
                    <div styleName="attribute-wrapper">
                      {customAttributes.length ? <Attribute data={plan} attributeName="offer_price" /> : null}
                    </div>
                  </div>
                </label>
              </div>
            );
          })}
        </div>
        <div>
          <label styleName="auto-renew-checkbox">
            <input type="checkbox" onChange={(e) => setIsRecurringPlan(e.target.checked)} />
            <span>Auto Renew when Subscription period is over</span>
          </label>
        </div>
        <div styleName="popup-message">{errorMessage}</div>
        <div styleName="subscribe-btn">
          <button onClick={() => handlePlanSelection(currentPlan)} disabled={isLoading}>
            {isLoading ? <span className="loader-icon">Loading...</span> : "Subscribe Now"}
          </button>
        </div>
      </div>
      <FaqSection />
    </>
  );
};

GroupsAndPlansModal.propTypes = {
  member: object,
  setActiveTab: func,
  initAccessType: func,
  subscriptionsData: object,
  setSelectedPlan: func,
  getSubscription: func,
  localizedMonths: object,
};
